module.exports = __webpack_public_path__ + "media/images/profile-c0d3596132e66514ba426608cd9f37a2.svg";